<template>
  <div class="aside" style="height: 100%; width: 100%">
    <el-row class="tac" style="height: 100%; width: 100%">
      <el-col :span="12" style="height: 100%; width: 100%">
        <el-menu
          :default-active="activeMenuPath"
          router
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          background-color="#FFFFFF"
          text-color="#54545D"
          active-text-color="#409EFF"
          style="height: 100%; width: 100%"
        >
			
			<!-- style="display: flex; align-items: center" -->
          <el-menu-item
            index="/create"
          >
            <!-- <img
              v-if="selectPath === '/create'"
              src="@/assets/images/sidebar_icon/sidebar_icon_active01.svg"
              alt="创建问卷"
            />
            <img
              v-else
              src="@/assets/images/sidebar_icon/sidebar_icon_inactive01.svg"
              alt="创建问卷"
            /> -->
            <i class="el-icon-circle-plus-outline"></i>
            <span slot="title">创建问卷</span>
          </el-menu-item>
          <el-menu-item index="/examCreate">
            <i class="el-icon-circle-plus-outline"></i>
            <span slot="title">创建考试</span>
          </el-menu-item>
          <el-menu-item index="/evaluationCreate">
            <i class="el-icon-circle-plus-outline"></i>
            <span slot="title">创建测评</span>
          </el-menu-item>
          <el-menu-item index="/HomePage">
            <i class="el-icon-document-remove"></i>
            <span slot="title">问卷模版</span>
          </el-menu-item>
          <el-menu-item index="/MyPage">
            <i class="el-icon-user"></i>
            <span slot="title">我的问卷</span>
          </el-menu-item>
          <el-menu-item index="/DataStatisticsPage">
            <i class="el-icon-receiving"></i>
            <span slot="title">数据统计</span>
          </el-menu-item>
          <el-menu-item index="/libraryList">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">题库列表</span>
          </el-menu-item>
          <el-menu-item index="/libraryEntry">
            <i class="el-icon-folder-add"></i>
            <span slot="title">添加题型</span>
          </el-menu-item>
          <el-menu-item index="/RecyclePage">
            <i class="el-icon-delete"></i>
            <!-- <img
              v-if="selectPath === '/RecyclePage'"
              src="@/assets/images/sidebar_icon/sidebar_icon_active01.svg"
              alt="创建问卷"
            />
            <img
              v-else
              src="@/assets/images/sidebar_icon/sidebar_icon_inactive01.svg"
              alt="创建问卷"
            /> -->
            <span slot="title">回收站</span>
          </el-menu-item>
          <el-menu-item index="/PersonalCenter">
            <i class="el-icon-user"></i>
            <span slot="title">个人中心</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectPath: "",
    };
  },
  computed: {
    // activeMenuPath() {
    // 	const firstPath = this.$route.path.split('/')[1];
    // 	return '/' + firstPath;
    // }
    activeMenuPath() {
      console.log("看看卡看看");
      if (localStorage.getItem("token")) {
        const path = this.$route.path;
        if (path === "/" || path === "/home") {
          return "/HomePage";
        }
        const firstPath = path.split("/")[1];
        return "/" + firstPath;
      } else {
        this.$router.replace("/");
      }
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.selectPath = key;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
span {
  font-size: 15px;
  font-weight: 600;
}

.menu-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  filter: grayscale(100%) brightness(0.5);
  transition: filter 0.3s ease;
}

.el-menu-item.is-active .menu-icon {
  filter: grayscale(0%) brightness(1);
  color: #409eff;
}

/* 为激活状态的图标添加蓝色效果 */
.el-menu-item.is-active .menu-icon {
  filter: hue-rotate(200deg) saturate(150%) brightness(1);
}
</style>



// WEBPACK FOOTER //
// src/components/asideNav.vue